import React from "react";

import { Image } from "@/components/atoms/Image";

export const ContentGiftCard = () => {
  return (
    <section className="banner-benefits">
      <Image
        pngSrc="/ventadigital/devolucion/assets/vida-devolucion/home/banner/icon-gift-card.png"
        alt="Icon Gift Card"
        fetchpriority="low"
      />
      <p>¡Participa por una Gift Card de S/100 por tu compra 100% digital!</p>
    </section>
  );
};
